module.exports = __webpack_public_path__ + "static/media/help.5991fcc7.svg";